import { render, staticRenderFns } from "./StepsScreenResolution.vue?vue&type=template&id=38b928fe&scoped=true&"
import script from "./StepsScreenResolution.vue?vue&type=script&lang=js&"
export * from "./StepsScreenResolution.vue?vue&type=script&lang=js&"
import style0 from "./StepsScreenResolution.vue?vue&type=style&index=0&id=38b928fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b928fe",
  null
  
)

export default component.exports